import React from 'react';

const HealthStatusLegend = () => {
  const legendItems = [
    {
      emoji: '🟢',
      label: 'HEALTHY',
      description: 'Tutto funzionante (WebSocket e API attivi < 2min, reader connesso)'
    },
    {
      emoji: '🟡',
      label: 'DEGRADED',
      description: 'Connessioni rallentate (WebSocket o API tra 2-10 minuti)'
    },
    {
      emoji: '🟠',
      label: 'WARNING',
      description: 'Problemi parziali (reader disconnesso, o solo WebSocket/API attivo)'
    },
    {
      emoji: '🔴',
      label: 'ERROR',
      description: 'Errori nel sistema del device'
    },
    {
      emoji: '⚫',
      label: 'OFFLINE',
      description: 'Device non raggiungibile (> 10 minuti o mai connesso)'
    },
    {
      emoji: '⚪',
      label: 'UNKNOWN',
      description: 'Nessun dato di salute disponibile'
    }
  ];

  return (
    <div style={{
      backgroundColor: '#f8f9fa',
      border: '1px solid #dee2e6',
      borderRadius: '8px',
      padding: '20px',
      marginTop: '30px'
    }}>
      <h3 style={{
        fontSize: '16px',
        fontWeight: 600,
        marginBottom: '15px',
        color: '#333'
      }}>
        📊 Leggenda degli stati dei devices
      </h3>
      
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '12px'
      }}>
        {legendItems.map((item, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '10px',
              padding: '8px',
              backgroundColor: 'white',
              borderRadius: '6px',
              border: '1px solid #e9ecef'
            }}
          >
            <span style={{ fontSize: '20px', flexShrink: 0 }}>
              {item.emoji}
            </span>
            <div style={{ flex: 1 }}>
              <div style={{
                fontWeight: 600,
                fontSize: '13px',
                color: '#333',
                marginBottom: '2px'
              }}>
                {item.label}
              </div>
              <div style={{
                fontSize: '12px',
                color: '#666',
                lineHeight: '1.4'
              }}>
                {item.description}
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div style={{
        marginTop: '15px',
        padding: '10px',
        backgroundColor: '#e7f3ff',
        borderRadius: '6px',
        fontSize: '12px',
        color: '#004085'
      }}>
        <strong>ℹ️ Nota:</strong> Lo stato viene calcolato in tempo reale da:
        <ul style={{ margin: '5px 0 0 20px', paddingLeft: 0 }}>
          <li><strong>WebSocket:</strong> Heartbeat ogni 30 secondi dal kiosk</li>
          <li><strong>API:</strong> Heartbeat ogni 2 minuti dal kiosk</li>
          <li><strong>Reader:</strong> Stato del terminale di pagamento Stripe</li>
        </ul>
      </div>
    </div>
  );
};

export default HealthStatusLegend;
